/* istanbul ignore file: this file does not contain any logic, only factory calls */
import { BaseOptions } from "@devowl-wp/utils";
/**
 * As we do not rely on a real store in our package (should be lightweight)
 * we can use the window object as variable.
 */

const getStaticOptions = () => window[BaseOptions.getPureSlug(process.env.slug, true)].others;

export { getStaticOptions };
export * from "./request";
export * from "./i18n";